import React from 'react';
import { useBodyScrollLock } from '../hooks/useBodyScrollLock';

interface ModalOverlayProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * Overlay skin. Defaults to the shared `.delete-modal-overlay` backdrop;
   * pass `tools-modal-overlay` / `wiki-create-overlay` for those variants.
   */
  className?: string;
}

/**
 * The bare backdrop div rendered by dialogs that don't go through `Modal`,
 * with the page scroll + zoom lock attached.
 *
 * Every one of these dialogs mounts its overlay only while open (either an
 * `isOpen` early-return or a conditional parent render), so the lock's
 * lifetime is exactly this component's lifetime — no `open` boolean to
 * thread through, and nothing to keep in sync when a dialog grows a new
 * dismissal path. `useBodyScrollLock` ref-counts, so stacked dialogs keep
 * the page pinned until the last one unmounts.
 */
const ModalOverlay: React.FC<ModalOverlayProps> = ({
  className = 'delete-modal-overlay',
  children,
  ...rest
}) => {
  useBodyScrollLock(true);
  return (
    <div className={className} {...rest}>
      {children}
    </div>
  );
};

export default ModalOverlay;
